import { render, staticRenderFns } from "./VideoEntityDetails.vue?vue&type=template&id=10084758&scoped=true"
import script from "./VideoEntityDetails.vue?vue&type=script&lang=js"
export * from "./VideoEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./VideoEntityDetails.vue?vue&type=style&index=0&id=10084758&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10084758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10084758')) {
      api.createRecord('10084758', component.options)
    } else {
      api.reload('10084758', component.options)
    }
    module.hot.accept("./VideoEntityDetails.vue?vue&type=template&id=10084758&scoped=true", function () {
      api.rerender('10084758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoEntityDetails.vue"
export default component.exports